import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class FormsSetupService {
  private apiUrl = `${config.examApiBaseUrl}/call`;

  constructor(private http: HttpClient) { }

  getformsSetup(FormQuestions: string): Observable<any> {
    const body = {
      procedureName: 'GetQuestionsByUnitAndType',
      params: {
        JsonData: FormQuestions
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getQuestions(UnitID: number, QuestionType: string, QuestionLevel: string, LanguageID:number): Observable<any> {
    const body = {
      procedureName: 'getAnotherQuestionsLevel',
      params: {
        UnitID: UnitID,
        QuestionType: QuestionType,
        QuestionLevel: QuestionLevel,
        LanguageID: LanguageID
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAnswersByQuestionID(QuestionID: number): Observable<any> {
    const body = {
      procedureName: 'GetAnswersByQuestionID',
      params: {
        QuestionID: QuestionID
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  updateItemInForm(UnitID: number, questionType: string, questionLevel: string): Observable<any> {
    const body = {
      procedureName: 'UpdateItemInForm',
      params: {
        UnitID: UnitID,
        QuestionType: questionType,
        QuestionLevel: questionLevel
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  updateFormNoForQuestions(formNo: number, questionIDs: number[]): Observable<any> {
    const body = {
      procedureName: 'UpdateFormNoForQuestions',
      params: {
        FormNo: formNo,
        QuestionIDs: questionIDs.join(',')
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAllForms(): Observable<any> {
    const body = {
      procedureName: 'GetAllFormsWithCourses',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getQuestionsByCourseAndForm(CourseID: number, FormNo: number, LangID: number): Observable<any> {
    const body = {
      procedureName: 'GetQuestionsByCourseAndForm',
      params: { 
        CourseID: CourseID,
        FormNo: FormNo,
        langID: LangID
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

}
